// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalInventoryLogs_root__MVss4","log":"ModalInventoryLogs_log__3_2NS","date":"ModalInventoryLogs_date__2TZU4","userName":"ModalInventoryLogs_userName__GgArh"};